// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --borderColor: gray;
  --charShape: none;
}

.col:last-child {
  width: 1% !important;
}

.pinCodeInput {
  width: 100% !important;
  border: 0px;
  border-bottom: 2px solid var(--borderColor);
  font-size: 24px;
  text-align: center;
  border-radius: 0px;
  padding: 0px;
  background: transparent;
  height: 44px;
}

.pinCodeGrid {
  direction: ltr;
}

.pinCodeInput[disabled] {
  border-bottom: 2px solid #e3e3e3;
  background-color: transparent;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pincode-input/pincode-input.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,6BAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF","sourcesContent":[":root {\n  --borderColor: gray;\n  --charShape: none;\n}\n\n.col:last-child {\n  width: 1% !important;\n}\n\n.pinCodeInput {\n  width: 100% !important;\n  border: 0px;\n  border-bottom: 2px solid var(--borderColor);\n  font-size: 24px;\n  text-align: center;\n  border-radius: 0px;\n  padding: 0px;\n  background: transparent;\n  height: 44px;\n}\n\n.pinCodeGrid {\n  direction: ltr;\n}\n\n.pinCodeInput[disabled] {\n  border-bottom: 2px solid #e3e3e3;\n  background-color: transparent;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
